module.exports = __webpack_public_path__ + "img/triangle-warning.dae13f71.svg";